import { render, staticRenderFns } from "./ChannelManagementProviderView.vue?vue&type=template&id=73013f53&"
import script from "./ChannelManagementProviderView.vue?vue&type=script&lang=js&"
export * from "./ChannelManagementProviderView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports